import {Box, Tab, Tabs} from "@mui/material";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import SectionHeader from "../../../util/component/SectionHeader";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {useHasScope} from "../../../config/globalConfig";
import {ETOLL_VIEW_CHARGES, ETOLL_VIEW_REPORTS} from "../utils/FinanceScope";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";
import ETollReport from "./etoll/sections/ETollReport";
import ETollCharges from "./etoll/sections/ETollCharges";
import ETollReportDetail from "./etoll/sections/ETollReportDetail";
import {STATE_ACTIVE_TAB_ETOLL, STATE_DISABLE_TAB_ETOLL} from "./etoll/constants/ETollConstants";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

const PageEToll = (props: any) => {
    const hasScope = useHasScope;
    const {t} = useTranslation('finance', {keyPrefix: 'etoll'});
    const [activeTab, setActiveTab] = useRecoilState(STATE_ACTIVE_TAB_ETOLL);
    const [disableTab, setDisableTab] = useRecoilState(STATE_DISABLE_TAB_ETOLL);
    const navigate = useNavigate();
    const location = useLocation();

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const tabReport = hasScope(ETOLL_VIEW_REPORTS);
    const tabCharges = hasScope(ETOLL_VIEW_CHARGES);
    const changeTabAndPath = (newValue: any) => {
        setActiveTab(newValue);
        if (newValue && newValue == 1) {
            navigate('/finance/e-toll/charges');
        } else {
            navigate('/finance/e-toll');
        }
    }

    useEffect(() => {
        if (location.pathname === "/finance/e-toll" || location.pathname === "/finance/e-toll/report") {

            if (!tabReport && tabCharges) {
                setActiveTab(1);
                navigate("/finance/e-toll/charges");
            } else {
                setActiveTab(0);
                navigate("/finance/e-toll/");
            }
        } else if (location.pathname === "/finance/e-toll/charges") {
            setActiveTab(1);
        }
    }, [location.pathname]);

    if (!hasScope(ETOLL_VIEW_REPORTS) && !hasScope(ETOLL_VIEW_CHARGES)) return (<NotAuthorizedDialog/>);

    return (
        <Box>
            <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
            {!disableTab &&

                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs value={activeTab} onChange={(_event, newValue: number) => changeTabAndPath(newValue)}>
                        {hasScope(ETOLL_VIEW_REPORTS) &&
                            <Tab label={t('tabs.report')} {...a11yProps(0)} />
                        }
                        {hasScope(ETOLL_VIEW_CHARGES) &&
                            <Tab label={t('tabs.charges')} {...a11yProps(1)} />
                        }
                    </Tabs>
                </Box>

            }
            {hasScope(ETOLL_VIEW_REPORTS) &&
                <TabPanel value={activeTab} index={0}>
                    <Routes>
                        <Route path="/" element={
                            <ETollReport/>
                        }>
                        </Route>
                        <Route path="/report/:id" element={
                            <ETollReportDetail/>
                        }>
                        </Route>
                    </Routes>
                </TabPanel>
            }
            {hasScope(ETOLL_VIEW_CHARGES) &&
                <TabPanel value={activeTab} index={1}>
                    <Routes>
                        <Route path="/charges" element={
                            <ETollCharges/>
                        }>
                        </Route>
                    </Routes>
                </TabPanel>
            }
        </Box>
    );
}

export default PageEToll;